




















import { Vue, Component, Prop } from 'vue-property-decorator';
import { initialHelper } from '@/common/helpers';

@Component
export default class Initials extends Vue {
  @Prop() fullName: string;
  @Prop() isSender: boolean;
  @Prop() scale: boolean;
  @Prop() hasValidatedValue: boolean;

  get initials(): string {
    return initialHelper(this.fullName);
  }
}
